import {create} from "zustand/react";

export interface MediaStore {
    searchText: string;
    selectedMediaId?: string;
    setSearchText: (text: string) => void;
    setSelectedMediaId: (id: string) => void;
}

export const useMediaStore = create<MediaStore>((set, getState) => ({
    searchText: "",
    selectedMediaId: undefined,
    setSearchText: (text) => {
        set((state) => {
            return {
                ...state,
                searchText: text
            }
        })
    },
    setSelectedMediaId: (id) => {
        set((state) => ({
            ...state
        }));
    },
}));
